import React, { useEffect, useState } from "react";
import { Col, Descriptions, Form, InputNumber, Modal, notification, Row, Table, Tag } from "antd";
import { CloseOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";

export default function ModalSelectLote({ exibirModal, fecharModal, dadosLote, dadosItem, dadosItemEditando }) {

    const [quantidadesLote, setQuantidadesLote] = useState({});

    useEffect(() => {
        if (Object.keys(dadosItem).length > 0 && dadosLote?.length > 0) {
            let quantidadeRestante = dadosItem.nfi_qtde;
            let novosValores = {};

            const lotesOrdenados = [...dadosLote].sort(
                (a, b) => new Date(a.prl_datavencimento) - new Date(b.prl_datavencimento)
            );

            for (let lote of lotesOrdenados) {
                if (quantidadeRestante <= 0) break;

                const quantidadeParaLote = Math.min(lote.saldo, quantidadeRestante);
                novosValores[lote.prl_id] = quantidadeParaLote;
                quantidadeRestante -= quantidadeParaLote;
            }

            setQuantidadesLote(novosValores);
        }
    }, [dadosItem, dadosLote]);

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                fecharModal();
            }
        })
    }

    function salvarLotes() {
        const listaTemp = Object.entries(quantidadesLote)
            .map(([prl_id, qtd]) => ({
                prl_id: Number(prl_id),
                nfl_qtde: qtd
            }))
            .filter(l => l.nfl_qtde > 0);

        const qtdeTotal = listaTemp.reduce((sum, l) => sum + l.nfl_qtde, 0);

        if (qtdeTotal < dadosItem.nfi_qtde) {
            notification.warning({
                message: 'Aviso!',
                description: 'Quantidade de Lotes menor que a quantidade do item.'
            });
        } else if (qtdeTotal > dadosItem.nfi_qtde) {
            notification.warning({
                message: 'Aviso!',
                description: 'A soma das quantidades dos lotes não pode exceder a quantidade do item.'
            });
        } else {
            fecharModal(dadosItem, listaTemp, dadosItemEditando);
        }
    };

    return (
        <Modal centered
            title="Lotes de Produto"
            width='35%'
            open={exibirModal}
            onCancel={onCloseModal}
            onOk={salvarLotes}
            okText={
                <>
                    <PlusOutlined /> Confirmar
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <div>
                <Form layout="vertical" name="formSelecionarLote" /*form={formulario}*/>
                    <Row gutter={[0, 8]}>
                        <Col>
                            <Descriptions size="small">
                                <Descriptions.Item>
                                    <b>{dadosItem.pro_descricao}</b>
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions>
                                <Descriptions.Item>
                                    Informe a quantidade do Lote escolhido
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    <div className="tabela">
                        <Table pagination={false} columns={
                            [
                                {
                                    title: 'Lote',
                                    width: 100,
                                    align: 'center',
                                    render: ({ prl_numerolote }) => (
                                        <Tag color={'processing'} className="w-100">
                                            <b>{prl_numerolote}</b>
                                        </Tag>
                                    )
                                },
                                {
                                    title: 'Data Entrada',
                                    align: 'center',
                                    render: ({ prl_dataentrada }) => (
                                        <b>{moment(prl_dataentrada).format('DD/MM/YYYY')}</b>
                                    )
                                },
                                {
                                    title: 'Data Fabricação',
                                    align: 'center',
                                    render: ({ prl_datafabricacao }) => (
                                        <b>{moment(prl_datafabricacao).format('DD/MM/YYYY')}</b>
                                    )
                                },
                                {
                                    title: 'Data Validade',
                                    align: 'center',
                                    render: ({ prl_datavencimento }) => (
                                        <b>{moment(prl_datavencimento).format('DD/MM/YYYY')}</b>
                                    ),
                                },
                                {
                                    title: 'Saldo',
                                    width: 75,
                                    align: 'center',
                                    render: ({ saldo }) => (
                                        <b>{saldo}</b>
                                    ),
                                },
                                {
                                    title: 'Quantidade',
                                    align: 'center',
                                    width: 100,
                                    render: (record) => (
                                        <InputNumber
                                            min={0}
                                            max={record.saldo}
                                            value={quantidadesLote[record.prl_id] || 0}
                                            onChange={(value) => {
                                                setQuantidadesLote(prev => ({
                                                    ...prev,
                                                    [record.prl_id]: value
                                                }));
                                            }}
                                        />
                                    )
                                }
                            ]
                        }
                            dataSource={dadosLote}
                            scroll={{ y: 240 }}
                        />
                    </div>
                </Form>
            </div>
        </Modal>
    )
}